import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import "../styles/terms.css";
import "../styles/bookingSection.css";
import { useEffect, useRef } from "react";
import Nav from "../components/Nav";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const handleContactBtn = () => {
    navigate("/get-in-touch");
  };

  const servicesRef = useRef(null);

  useEffect(() => {
    const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");

    const scrollReveal = () => {
      for (let i = 0; i < revealElements.length; i++) {
        const elementIsInScreen =
          revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;

        if (elementIsInScreen) {
          revealElements[i].classList.add("revealed");
        } else {
          revealElements[i].classList.remove("revealed");
        }
      }
    };

    window.addEventListener("scroll", scrollReveal);
    scrollReveal();

    return () => {
      window.removeEventListener("scroll", scrollReveal);
    };
  }, []);

  return (
    <>
      <div className="home__wrapper">
        <Nav />

        <div className="terms-wrapper">
          <div className="terms-container">
            <h1>Privacy Policy</h1>

            <p>
              This Privacy Policy explains how Roarz Kreatives ("Roarz", "we", "us",
              or "our") collects, uses, stores, shares, and protects personal
              information when you use our website, contact us, submit a form,
              engage our services, or interact with us through third-party
              platforms including social media, CRM systems, and lead generation
              tools.
            </p>

            <h2>1. Who We Are</h2>
            <p>
              Roarz Kreatives is a creative, marketing, branding, media, and digital
              services business. If you have questions about this Privacy Policy or
              our handling of personal data, you can contact us at{" "}
              <a href="mailto:hello@roarzkreatives.com">hello@roarzkreatives.com</a>.
            </p>

            <h2>2. Information We Collect</h2>
            <p>We may collect personal information including:</p>
            <ul>
              <li>Name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Business name</li>
              <li>Location details you provide</li>
              <li>Project details, enquiry details, and message content</li>
              <li>Marketing preferences and communication preferences</li>
              <li>Technical data such as IP address, browser type, device data, and website usage information</li>
              <li>Lead data submitted through forms, ads, CRM integrations, and social media platforms such as TikTok</li>
            </ul>

            <h2>3. How We Collect Information</h2>
            <p>We may collect information directly from you when you:</p>
            <ul>
              <li>Fill in a contact form or booking form on our website</li>
              <li>Contact us by email, phone, WhatsApp, or social media</li>
              <li>Request a quote or engage our services</li>
              <li>Respond to an advertisement or submit a lead form</li>
              <li>Interact with our website through cookies or analytics tools</li>
            </ul>

            <p>We may also receive information from third parties, including:</p>
            <ul>
              <li>TikTok Lead Generation and other advertising platforms</li>
              <li>CRM systems and automation tools</li>
              <li>Analytics providers</li>
              <li>Communication and hosting service providers</li>
            </ul>

            <h2>4. How We Use Personal Information</h2>
            <p>We may use personal information to:</p>
            <ul>
              <li>Respond to enquiries and requests</li>
              <li>Provide quotations and services</li>
              <li>Manage projects and customer relationships</li>
              <li>Contact you regarding services, bookings, proposals, and support</li>
              <li>Process and manage leads generated through our website or advertising campaigns</li>
              <li>Operate, improve, and secure our website, systems, and services</li>
              <li>Maintain records for administration, legal, and compliance purposes</li>
              <li>Send marketing communications where lawful and appropriate</li>
            </ul>

            <h2>5. TikTok Leads, CRM Integrations and Third-Party Platforms</h2>
            <p>
              If you submit your information through a TikTok lead form, website form,
              or another connected platform, your information may be sent to Roarz
              Kreatives and stored in our CRM, communication systems, or internal
              business tools so that we can respond to your enquiry, provide services,
              follow up on your interest, and maintain business records.
            </p>

            <p>
              This may include personal data such as your name, phone number, email
              address, business information, and any information you submit in the
              form or message.
            </p>

            <p>
              We may use this information to contact you by email, phone, WhatsApp,
              SMS, or other appropriate channels in relation to your enquiry,
              requested services, or legitimate business follow-up, subject to
              applicable law.
            </p>

            <h2>6. Legal Basis and Compliance</h2>
            <p>
              We handle personal information in accordance with applicable law,
              including the Kenya Data Protection Act, 2019 where applicable. Depending
              on the circumstances, we may process personal data based on consent,
              performance of a contract, legitimate interests, compliance with legal
              obligations, or other lawful grounds permitted by law.
            </p>

            <h2>7. Sharing of Information</h2>
            <p>We may share personal information with:</p>
            <ul>
              <li>Our employees, contractors, and authorised service providers</li>
              <li>Website hosting, analytics, CRM, communication, and cloud service providers</li>
              <li>Advertising and social media platforms where needed for campaign management</li>
              <li>Professional advisers, regulators, courts, or authorities where required by law</li>
            </ul>

            <p>
              We do not sell personal information. We only share information where
              reasonably necessary for business operations, service delivery,
              compliance, security, or lawful purposes.
            </p>

            <h2>8. Data Retention</h2>
            <p>
              We retain personal information only for as long as reasonably necessary
              for the purposes for which it was collected, including to respond to
              enquiries, provide services, maintain records, resolve disputes, enforce
              agreements, and comply with legal obligations.
            </p>

            <h2>9. Data Security</h2>
            <p>
              We take reasonable technical and organisational measures to protect
              personal information against unauthorised access, loss, misuse,
              alteration, or disclosure. However, no method of internet transmission
              or electronic storage is completely secure, and we cannot guarantee
              absolute security.
            </p>

            <h2>10. Cookies and Analytics</h2>
            <p>
              Our website may use cookies, pixels, tags, and analytics technologies to
              improve website performance, understand visitor behaviour, measure
              campaign performance, and enhance user experience. You may be able to
              control some cookies through your browser settings.
            </p>

            <h2>11. Your Rights</h2>
            <p>
              Subject to applicable law, you may have rights to request access to
              personal data we hold about you, request correction of inaccurate data,
              object to certain processing, request deletion where appropriate, or
              withdraw consent where processing is based on consent.
            </p>

            <p>
              To make a privacy-related request, please contact us at{" "}
              <a href="mailto:hello@roarzkreatives.com">hello@roarzkreatives.com</a>.
            </p>

            <h2>12. Third-Party Websites and Platforms</h2>
            <p>
              Our website, advertisements, or communications may link to third-party
              websites or platforms. We are not responsible for the privacy practices,
              terms, or content of third-party services, including TikTok and other
              external platforms. Your use of those services is subject to their own
              terms and privacy notices.
            </p>

            <h2>13. Children’s Privacy</h2>
            <p>
              Our services are not directed to children unless expressly stated
              otherwise. We do not knowingly collect personal information from children
              in violation of applicable law.
            </p>

            <h2>14. Changes to this Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes will be
              posted on this page with an updated revision date. Continued use of our
              website or services after updates are posted constitutes acknowledgement
              of the revised Privacy Policy.
            </p>

            <h2>15. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy or how we handle
              personal information, please contact us at{" "}
              <a href="mailto:hello@roarzkreatives.com">hello@roarzkreatives.com</a>.
            </p>

            <footer>
              <p>Last updated: April 8, 2026</p>
            </footer>
          </div>
        </div>

        <section className="booking-wrapper" ref={servicesRef}>
          <div className="booking-content">
            <h3 data-reveal>Let's get to work</h3>
            <p data-reveal>
              Ready to get started? Book a Discovery Call so we can learn more
              about your needs and discuss how we can help.
            </p>
            <button className="get-started-btn" onClick={handleContactBtn}>
              Get Started <span className="plus-icon">+</span>
            </button>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default PrivacyPolicy;